import { OptionsData, TreeSelectOptions } from '../models';

export const TREE_SELECT_OPTIONS_IF: TreeSelectOptions[] = [
  {
    key: '0',
    label: 'Opción 1',
    data: 'Opción 1',
    children: [
      {
        key: '0-0',
        label: 'Tender Data',
        data: 'Tender Folder',
        tag: 'Toggle',
      },
    ],
  },
  {
    key: '1',
    label: 'Start Load',
    data: 'Start Load Data',
    children: [
      {
        key: '1-0',
        label: 'Hooked Or Loaded',
        data: 'Hooked Or Loaded',
        tag: 'Toggle',
      },
      {
        key: '1-1',
        label: 'Form Hooked',
        data: 'Form Hooked',
        tag: 'Button',
      },
      {
        key: '1-2',
        label: 'Form Loaded',
        data: 'Form Loaded',
        tag: 'Button',
      },
      {
        key: '1-3',
        label: 'Pre Trip Inspection',
        data: 'Pre Trip Inspection',
        children: [
          {
            key: '1-3-0',
            label: 'Value Name',
            data: 'Value Name',
            tag: 'Input',
          },
          {
            key: '1-3-1',
            label: 'Trailer Damage',
            data: 'Trailer Damage',
            tag: 'Input',
          },
          {
            key: '1-3-2',
            label: 'Certify Pass',
            data: 'Certify Pass',
            tag: 'Input',
          },
          {
            key: '1-3-3',
            label: 'Scan Documents',
            data: 'Scan Documents',
            tag: 'Input',
          },
          {
            key: '1-3-4',
            label: 'Completed Step',
            data: 'Completed Step',
            tag: 'Input',
          },
        ],
      },
      {
        key: '1-4',
        label: 'Pre Trip',
        data: 'Pre Trip',
        tag: 'Toggle',
      },
      {
        key: '1-5',
        label: 'Depart',
        data: 'Depart',
        tag: 'Toggle',
      },
    ],
  },
];

export const TREE_SELECT_OPTIONS_THEN: TreeSelectOptions[] = [
  {
    key: '0',
    label: 'Opción 2',
    data: 'Opción 2',
    tag: 'Text',
  },
  {
    key: '1',
    label: 'False',
    data: 'false',
    tag: 'Toggle',
  },
  {
    key: '2',
    label: 'Testing large text for label',
    data: 'false',
    tag: 'Toggle',
  },
];

export const TREE_SELECT_OPTIONS_CUSTOM: TreeSelectOptions[] = [
  {
    key: '0',
    label: 'Documents',
    data: 'Documents Folder',
    children: [
      {
        key: '0-0',
        label: 'Work',
        data: 'Work Folder',
        children: [
          {
            key: '0-0-0',
            label: 'Expenses.doc',
            data: 'Expenses Document',
          },
          {
            key: '0-0-1',
            label: 'Resume.doc',
            data: 'Resume Document',
          },
        ],
      },
      {
        key: '0-1',
        label: 'Home',
        data: 'Home Folder',
        children: [
          {
            key: '0-1-0',
            label: 'Invoices.txt',
            data: 'Invoices for this month',
          },
        ],
      },
    ],
  },
  {
    key: '1',
    label: 'Events',
    data: 'Events Folder',
    children: [
      {
        key: '1-0',
        label: 'Meeting',
        data: 'Meeting',
      },
      {
        key: '1-1',
        label: 'Product Launch',
        data: 'Product Launch',
      },
      {
        key: '1-2',
        label: 'Report Review',
        data: 'Report Review',
      },
    ],
  },
  {
    key: '2',
    label: 'Movies',
    data: 'Movies Folder',
    children: [
      {
        key: '2-0',
        label: 'Al Pacino',
        data: 'Pacino Movies',
        children: [
          {
            key: '2-0-0',
            label: 'Scarface',
            data: 'Scarface Movie',
          },
          {
            key: '2-0-1',
            label: 'Serpico',
            data: 'Serpico Movie',
          },
        ],
      },
      {
        key: '2-1',
        label: 'Robert De Niro',
        data: 'De Niro Movies',
        children: [
          {
            key: '2-1-0',
            label: 'Goodfellas',
            data: 'Goodfellas Movie',
          },
          {
            key: '2-1-1',
            label: 'Untouchables',
            data: 'Untouchables Movie',
          },
        ],
      },
    ],
  },
];

export const DROPDOWN_OPERATORS: OptionsData<string>[] = [
  {
    label: 'Is Equal To',
    value: 'Equal',
  },
  {
    label: 'Is Different Than',
    value: 'NotEqual',
  },
  {
    label: 'Greater Than',
    value: 'GreaterThan',
  },
  {
    label: 'Less Than',
    value: 'LessThan',
  },
  {
    label: 'Greater than or equal to',
    value: 'GreaterThanOrEqual',
  },
  {
    label: 'Less than or equal to',
    value: 'LessThanOrEqual',
  },
  {
    label: 'Is Completed',
    value: 'IsCompleted',
  },
  {
    label: 'Is Incomplete',
    value: 'IsIncomplete',
  },
];

export const DROPDOWN_ACTIONS: OptionsData<string>[] = [
  {
    label: 'Duplicate {Step, Segment Action} ',
    value: 'duplicate',
  },
  {
    label: 'Save {Step, Segment Action} as Templet ',
    value: 'saveTemplate',
  },
  {
    label: 'Delete',
    value: 'delete',
    icon: 'trash',
    prime: false,
  },
];
